// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__3V1Fq","title":"AfterImages45_title__2MZZb","images":"AfterImages45_images__W_sfF"};